// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XDVB","icon":"styles_icon__2Mbpf"};